import React, { useState, useEffect } from "react";
import { colors } from "../../../../../../../../../themes/Colors";
import BaseButtons from "../../../../../../../base-buttons/BaseButtons";
import ImageUploadAWS from "../../../../../../../../user/components/image-upload/ImageUploadAWS";
import TextInputFieldArea from "../../../../../../../text-input-field/TextInputFieldArea";
import TextInputField from "../../../../../../../text-input-field/TextInputField";

const validFileTypes = ["image/jpg", "image/jpeg", "image/png"];

const AddPopUp = ({
  display,
  onCloseClick,
  name,
  data,
  setMessage,
  setToastPop,
  setPopUpTitle,
  setPopUpDisplay,
  setLoading,
}) => {
  const [image, setImage] = useState(null);
  const [imageError, setImageError] = useState(null);
  const handleFileChange = (e) => {
    // Uploaded file
    const file = e.target.files[0];
    // Changing file state
    setImage(file);
  };

  const [incidentDate, setIncidentDate] = useState("");
  const [incidentTime, setIncidentTime] = useState("");

  const [incidentLocation, setIncidentLocation] = useState("");
  const [sapsCaseNr, setSapsCaseNr] = useState("");

  const [vehicleLiscenseNr, setVehicleLiscenseNr] = useState("");

  const [vehicleColor, setVehicleColor] = useState("");

  const [make, setMake] = useState("");
  const [series, setSeries] = useState("");

  const [contactPerson, setContactPerson] = useState("");
  const [contactNumber, setContactNumber] = useState("");

  const [additonalInfo, setAdditonalInfo] = useState("");

  const [otherVehicleLiscenseNr, setOtherVehicleLiscenseNr] = useState("");

  const [otherVehicleColor, setOtherVehicleColor] = useState("");

  const [otherMake, setOtherMake] = useState("");
  const [otherSeries, setOtherSeries] = useState("");

  const [otherContactPerson, setOtherContactPerson] = useState("");
  const [otherContactNumber, setOtherContactNumber] = useState("");

  const [otherAdditonalInfo, setOtherAdditonalInfo] = useState("");

  const ClearData = () => {
    setIncidentDate("");
    setIncidentTime("");

    setIncidentLocation("");
    setSapsCaseNr("");

    setVehicleLiscenseNr("");
    setVehicleColor("");
    setMake("");
    setSeries("");
    setContactPerson("");
    setContactNumber("");
    setAdditonalInfo("");
    setOtherVehicleLiscenseNr("");
    setOtherVehicleColor("");
    setOtherMake("");
    setOtherSeries("");
    setOtherContactPerson("");
    setOtherContactNumber("");
    setOtherAdditonalInfo("");
  };

  const CreateAccidentReport = async (e) => {
    setLoading(true);
    let file = image;

    if (!validFileTypes.find((type) => type === file.type)) {
      setImageError("File type must be JPG or PNG format");
      setLoading(false);
      return;
    } else {
      setImageError("");
    }
    try {
      const formData = new FormData();
      formData.append("image", file);
      formData.append("vehicleIdentifier", data._id);
      formData.append("incidentDate", incidentDate);
      formData.append("incidentTime", incidentTime);
      formData.append("incidentLocation", incidentLocation);
      formData.append("SapsCaseNr", sapsCaseNr);
      formData.append("vehicleLiscenseNr", data.liscenseNumber);

      formData.append("vehicleMake", data.make);
      formData.append("vehicleSeries", data.series);

      formData.append("vehicleColor", vehicleColor);
      formData.append("contactPerson", contactPerson);

      formData.append("contactNumber", contactNumber);
      formData.append("additonalInfo", additonalInfo);

      formData.append("otherVehicleLiscenseNr", otherVehicleLiscenseNr);
      formData.append("otherVehicleMake", otherMake);
      formData.append("otherVehicleSeries", otherSeries);
      formData.append("otherVehicleColor", otherVehicleColor);
      formData.append("othgerContactPerson", otherContactPerson);
      formData.append("otherContactNumber", otherContactNumber);

      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/vehicleAction/crearAccidentReport",
        {
          method: "POST",
          body: formData,
        }
      );
      const respnseData = await response.json();

      if (respnseData.success) {
        // setPrivateInfoPopUp(false);
        setToastPop(true);
        setMessage(respnseData.success);
        setPopUpTitle("SUCCESS");
        setLoading(false);
        setPopUpDisplay(false);
        ClearData();
        // setVehicleSearchArray(respnseData.enatisVehicles);
      } else {
        setToastPop(true);
        setMessage(respnseData.error);
        setPopUpTitle("FAILURE");
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };
  useEffect(() => {
    if (data) {
      setMake(data.make);
      setSeries(data.series);
      setVehicleLiscenseNr(data.liscenseNumber);
    }
  }, [display]);
  return (
    <div
      style={{
        position: "fixed",
        width: "100%",
        height: display ? "100%" : 0,
        backgroundColor: colors.white,
        zIndex: 20,
        top: 0,
        overflowY: display ? "scroll" : "hidden",
        overflowX: display ? "scroll" : "hidden",
        transition: "all 0.2s",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: 20,
          top: 30,
          display: "flex",
          alignItems: "center",
        }}
      >
        {" "}
        <div
          onClick={onCloseClick}
          style={{
            height: 60,
            width: 90,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: 2,
            borderColor: colors.white,
            transition: "all 0.3s",
            WebkitBoxShadow: "-5px 5px 15px -1px #00000070",

            borderBottomRightRadius: 10,
            borderBottomLeftRadius: 10,
            backgroundColor: colors.orangeDark,
          }}
        >
          <div
            style={{
              marginTop: 10,
              fontWeight: "bold",
              color: colors.white,
              transition: "all 0.3s",
            }}
          >
            BACK
          </div>
        </div>
        <div
          style={{
            marginTop: 10,
            marginLeft: 20,
            fontWeight: "bold",
            fontSize: 18,
          }}
        >
          ACCIDENT DETAILS
        </div>
      </div>
      {/* main page dtata and view */}
      <div
        style={{
          flex: 1,
          height: "100%",
          overflowY: "hidden",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ minHeight: 100, width: "100%" }} />
        <div
          style={{
            flex: 1,
            overflowY: "scroll",
            overflowX: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <TextInputField
            labelTitle={"Incident Date"}
            mini={true}
            width={"100%"}
            size={"80%"}
            value={incidentDate}
            onChange={(e) => setIncidentDate(e.target.value)}
          />
          <TextInputField
            labelTitle={"Incident Time"}
            mini={true}
            width={"100%"}
            size={"80%"}
            value={incidentTime}
            onChange={(e) => setIncidentTime(e.target.value)}
          />
          <TextInputField
            labelTitle={"Incident location"}
            mini={true}
            width={"100%"}
            size={"80%"}
            value={incidentLocation}
            onChange={(e) => setIncidentLocation(e.target.value)}
          />
          <TextInputField
            labelTitle={"SAPS case nr"}
            mini={true}
            width={"100%"}
            size={"80%"}
            value={sapsCaseNr}
            onChange={(e) => setSapsCaseNr(e.target.value)}
          />
          <TextInputFieldArea
            labelTitle={"Additional Info"}
            mini={true}
            width={"100%"}
            size={"80%"}
            height={100}
            value={additonalInfo}
            onChange={(e) => setAdditonalInfo(e.target.value)}
          />
          <div
            style={{
              width: "100%",
              marginTop: 15,
              marginBottom: 15,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "80%",
                textAlign: "left",
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              MY VEHICLE
            </div>
          </div>
          <TextInputField
            labelTitle={"Liscense nr"}
            mini={true}
            width={"100%"}
            size={"80%"}
            value={vehicleLiscenseNr}
            onChange={(e) => setVehicleLiscenseNr(e.target.value)}
          />
          <TextInputField
            labelTitle={"Make"}
            mini={true}
            width={"100%"}
            size={"80%"}
            value={make}
            onChange={(e) => setMake(e.target.value)}
          />
          <TextInputField
            labelTitle={"Series"}
            mini={true}
            width={"100%"}
            size={"80%"}
            value={series}
            onChange={(e) => setSeries(e.target.value)}
          />
          <TextInputField
            labelTitle={"Color"}
            mini={true}
            width={"100%"}
            size={"80%"}
            value={vehicleColor}
            onChange={(e) => setVehicleColor(e.target.value)}
          />
          <TextInputField
            labelTitle={"Drivers name"}
            mini={true}
            width={"100%"}
            size={"80%"}
            value={contactPerson}
            onChange={(e) => setContactPerson(e.target.value)}
          />
          <TextInputField
            labelTitle={"Drivers number"}
            mini={true}
            width={"100%"}
            size={"80%"}
            value={contactNumber}
            onChange={(e) => setContactNumber(e.target.value)}
          />
          <div
            style={{
              width: "100%",
              marginTop: 15,
              marginBottom: 15,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "80%",
                textAlign: "left",
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              OTHER VEHICLE
            </div>
          </div>
          <TextInputField
            labelTitle={"Liscense nr"}
            mini={true}
            width={"100%"}
            size={"80%"}
            value={otherVehicleLiscenseNr}
            onChange={(e) => setOtherVehicleLiscenseNr(e.target.value)}
          />
          <TextInputField
            labelTitle={"Make"}
            mini={true}
            width={"100%"}
            size={"80%"}
            value={otherMake}
            onChange={(e) => setOtherMake(e.target.value)}
          />
          <TextInputField
            labelTitle={"Series"}
            mini={true}
            width={"100%"}
            size={"80%"}
            value={otherSeries}
            onChange={(e) => setOtherSeries(e.target.value)}
          />
          <TextInputField
            labelTitle={"Color"}
            mini={true}
            width={"100%"}
            size={"80%"}
            value={otherVehicleColor}
            onChange={(e) => setOtherVehicleColor(e.target.value)}
          />
          <TextInputField
            labelTitle={"Drivers name"}
            mini={true}
            width={"100%"}
            size={"80%"}
            value={otherContactPerson}
            onChange={(e) => setOtherContactPerson(e.target.value)}
          />
          <TextInputField
            labelTitle={"Drivers number"}
            mini={true}
            width={"100%"}
            size={"80%"}
            value={otherContactNumber}
            onChange={(e) => setOtherContactNumber(e.target.value)}
          />

          <div
            style={{
              width: "100%",
              marginTop: 15,
              marginBottom: 15,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "80%",
                textAlign: "left",
                fontSize: 14,
                fontWeight: "bold",
              }}
            >
              INCIDENT IMAGE
            </div>
          </div>
          <ImageUploadAWS
            onChange={(e) => handleFileChange(e)}
            labelTitle={"Upload Motor Vehicle Accident image"}
            mini={true}
            errorDisplay={imageError}
            width={"100%"}
            size={"80%"}
          />
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: 20,
              marginBottom: 20,
            }}
          >
            <BaseButtons
              label={"CANCEL"}
              backgroundColor={colors.orangeDark}
              width={"40%"}
              borderRadius={8}
              onClick={onCloseClick}
            />
            <BaseButtons
              label={"SUBMIT"}
              backgroundColor={colors.greenDark}
              width={"40%"}
              borderRadius={8}
              onClick={() => CreateAccidentReport()}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPopUp;
